<a
    class="badge fx-row fx-layout-align-start-center"
    [class.header]="headerStyle"
    [routerLink]="['/locations', 'l', 'location', location?.id || globalSearchLocation?.locationUid]"
>
    <!-- location icon -->
    <mat-icon svgIcon="c-location"></mat-icon>

    <!-- location info -->
    <div class="info fx-column fx-flex">
        <span class="content">
            {{ location?.name || globalSearchLocation?.locationName | ceCustomerPrivacy: 'location' }}
        </span>
        <span>{{
            addressLine ||
                globalSearchLocation?.address ||
                globalSearchLocation?.city ||
                (globalSearchLocation?.country | ceCustomerPrivacy: 'address') ||
                'Location'
        }}</span>
    </div>
</a>
